export default __webpack_public_path__ + "static/duration-filter-dark-mode-8580a5ea22faf7e53e30d17680674cfb.png";